import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from "@angular/core";
import { ICellRendererAngularComp } from "@bfx/ag-grid-angular";
import { ICellRendererParams } from "ag-grid-community";

@Component({
  selector: "fill-percent",
  template: '<div class="div-percent-outer-div">{{this.valueFormatted}}</div>',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class FillRenderer implements ICellRendererAngularComp {
  public valueFormatted: string;
  previous: { valueFormatted: string };

  constructor(public cd: ChangeDetectorRef) {
    this.previous = { valueFormatted: this.valueFormatted };
  }

  // called on init
  agInit(params: ICellRendererParams): void {
    this.doVal(params);
  }

  doVal(params: ICellRendererParams): boolean {
    this.previous.valueFormatted = this.valueFormatted;

    this.valueFormatted = params.valueFormatted;

    return this.valueFormatted !== this.previous.valueFormatted;
  }

  // called when the cell is refreshed
  refresh(params: ICellRendererParams): boolean {
    if (this.doVal(params)) {
      this.cd.markForCheck();
    }

    return true;
  }
}
